import React from "react";
import LookupValuesEditor from "./shared/LookupValuesEditor";

const Departments = () => (
  <LookupValuesEditor
    kind="departments"
    singular="department"
    plural="departments"
  />
);

export default Departments;
